import React from 'react'
import Layout from '../../components/layout/layout'
import DeviceConf from '../../components/configuration-templates/configuration-custom-template/template.component'
export default function DeviceConfiguration() {
  return (
    <Layout>
      <DeviceConf />
    </Layout>
  )
}
